import Swiper from '../libs/swiper.4.5.0.min'

$(function () {
  var $block = $('.b-gallery-header'),
    $gallery_image_text = $block.find('.gallery-image-text')

  if (!$block.length) {
    return
  }

  function loadGallery() {
    IB.currentDevice !== 'mobile' &&
    (IB.currentDevice === 'tablet' || $('.gallery-preview').hasClass('gallery-image-big'))
      ? 5
      : 3

    var swiper_gallery_image = new Swiper($block.find('.gallery-image:not(.loaded)').addClass('loaded'), {
      spaceBetween: 10,
      preloadImages: false,
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      loop: true,
      loopedSlides: 5,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      on: {
        transitionEnd() {
          updateDescription($block.find('.gallery-image .swiper-slide-active'))
        },
      },
    })

    new Swiper($block.find('.gallery-preview:not(.loaded)').addClass('loaded'), {
      slidesPerView: 4,
      spaceBetween: MQBE.current_state() === 'desktop' ? 20 : 6,
      navigation: {
        nextEl: '.slider-next',
        prevEl: '.slider-prev',
      },
      loop: true,
      loopedSlides: 5,
      preloadImages: false,
      lazyLoading: true,
      direction: MQBE.current_state() === 'desktop' ? 'vertical' : 'horizontal',
      thumbs: {
        swiper: swiper_gallery_image,
      },
      on: {
        transitionEnd() {
          updateDescription($block.find('.gallery-image .swiper-slide-active'))
        },
      },
    })
  }

  function updateDescription(slide) {
    var index = slide.data('image-index')
    $gallery_image_text.addClass('hide-text')
    $block.find(`.gallery-image-text[data-text-index="${index}"]`).removeClass('hide-text')
  }

  function unloadGallery() {
    $block
      .find('.gallery-preview.loaded')
      .removeClass('loaded')
      .removeClass('swiper-container-horizontal')
      .removeClass('swiper-container-vertical')
      .find('.swiper-wrapper, .swiper-slide')
      .attr('style', '')
  }

  ;(function init() {
    loadGallery()
  })()

  $(document).on('enter.desktop.mqbe', function () {
    unloadGallery()
    loadGallery()
  })

  $(document).on('enter.tablet.mqbe', function () {
    unloadGallery()
    loadGallery()
  })

  $(document).on('enter.mobile.mqbe', function () {
    unloadGallery()
    loadGallery()
  })

  $(window).on('orientationchange', function () {
    unloadGallery()
    loadGallery()
  })
})
